<ph-dialog [open]="open" size="sm" [heading]="heading" icon="image" [noClose]="saving" (ph-close)="close()">
    <ph-stack>
        <ph-spinner *ngIf="saving" size="32" center label="Saving logo…"></ph-spinner> <!-- kitlint-allow-spinner: dialog's own busy moment -->

        <ph-file-upload *ngIf="!logoDataUrl && !saving"
                        [accept]="accept"
                        [hint]="hint"
                        (ph-files)="onFiles($event)"></ph-file-upload>

        <ng-container *ngIf="logoDataUrl && !saving">
            <ph-toolbar>
                <ph-file-thumbnail [src]="logoDataUrl"
                                   [alt]="heading"
                                   size="lg"
                                   removeLabel="Remove selected image"
                                   (ph-remove)="clear()"></ph-file-thumbnail>
                <ph-hint>{{ fileName }}</ph-hint>
            </ph-toolbar>
            <ph-alert *ngIf="underSized" status="warning" variant="lighter">
                Uploaded image is under the recommended size ({{ recommendedSize }}). Saved image may appear smaller or blurry.
            </ph-alert>
            <ph-hint>{{ hint }}</ph-hint>
        </ng-container>
    </ph-stack>

    <ph-actions slot="footer" *ngIf="!saving">
        <ph-button variant="secondary" mode="stroke" type="button" (click)="close()">Cancel</ph-button>
        <ph-button variant="primary" mode="filled" type="button" [disabled]="!logoDataUrl" (click)="submit()">Save logo</ph-button>
    </ph-actions>
</ph-dialog>
